module.exports = __webpack_public_path__ + "static/media/analytics1.69de88a1.svg";